import { lory } from 'lory.js';

var Banners = (function() {
  'use strict';

  function init() {
    const slider = document.querySelector('.banners.js_slider');
    const numberOfBanners = slider.querySelectorAll('.js_slide').length;
    if (numberOfBanners > 3) {
      lory(slider, {
        infinite: numberOfBanners,
        slidesToScroll: 1,
      });
    } else {
      slider.querySelector('.js_next').style = 'display:none';
      slider.querySelector('.js_prev').style = 'display:none';
    }
  }

  return {
    init: init,
  };
})();

export { Banners as default };



// WEBPACK FOOTER //
// ./client_src/js/modules/Banners.js